const arrayze = (a: any) => (Array.isArray(a) ? a : [a])

const naiveIsArrayOfStrs = (a: any) => (Array.isArray(a) ? (a.length > 0 ? typeof a[0] === "string" : false) : false)

const naiveIsObj = (a: any) => typeof a === "object" && a !== null && !Array.isArray(a)

export const transformErrorForForm = (error: any, skipTransform: boolean | string[] = false) => {
  if (error.response?.status === 400) {
    let errorData
    if (naiveIsObj(error?.data)) {
      errorData = error.data as Record<string, any>
    }

    const makeErrors = (errorObj: Record<string, any>): Record<string, any> => {
      return Object.keys(errorObj).reduce((transformed, key) => {
        const rawError = errorObj[key]
        let error
        if (
          skipTransform !== false &&
          (skipTransform === true || (Array.isArray(skipTransform) && skipTransform.includes(key)))
        ) {
          return {
            ...transformed,
            [key]: rawError,
          }
        }
        if (naiveIsObj(rawError)) {
          error = makeErrors(rawError)
        } else if (naiveIsArrayOfStrs(rawError)) {
          error = arrayze(errorObj[key]).join(" ")
        } else if (Array.isArray(rawError)) {
          error = rawError.map((err) => makeErrors(err))
        } else {
          error = arrayze(errorObj[key]).join(" ")
        }
        return {
          ...transformed,
          [key]: error,
        }
      }, {})
    }

    if (errorData) {
      return makeErrors(errorData)
    }
  }
  // When no 400 (not related 2 form)
  // add a special __noFieldsServerError key \w original error
  return {
    __noFieldsServerError: error,
  }
}

export const omit = (keys: string[], obj: Record<string, any>) =>
  Object.fromEntries(Object.entries(obj).filter(([k]) => !keys.includes(k)))

export const slugify = (str: string) => {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, "-")
}


